// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { Unit } from '../../../../../com/MetaPattern/APP/MDA/ModelLib/Unit';
/**
 * 元件信息DTO DTO类
 * 元件信息DTO，包含了元件的所属者
 */
export class UnitInfoDTO {
  /** 元件 : 元件 */
  private _unit: Unit;

  /** 设置：元件 */
  public get unit() {
    return this._unit;
  }

  /** 获取：元件 */
  public set unit(value: Unit) {
    this._unit = value;
  }

  /** 租户名称 : 租户名称 */
  private _tenancyName: string;

  /** 设置：租户名称 */
  public get tenancyName() {
    return this._tenancyName;
  }

  /** 获取：租户名称 */
  public set tenancyName(value: string) {
    this._tenancyName = value;
  }

  constructor() {
    this._unit = new Unit();
    this._tenancyName = '';
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.unit = json.Unit as Unit;
    this.tenancyName = json.TenancyName;
  }

  protected Serialize(json: any): void {
    json.Unit = this.unit;
    json.TenancyName = this.tenancyName;
  }

  static Create(json: any): UnitInfoDTO {
    const unitInfoDTO = new UnitInfoDTO();
    unitInfoDTO.Deserialize(json);
    return unitInfoDTO;
  }
}
